import { render, staticRenderFns } from "./idCardPrinting.vue?vue&type=template&id=0efcabc0&scoped=true"
import script from "./idCardPrinting.vue?vue&type=script&lang=js"
export * from "./idCardPrinting.vue?vue&type=script&lang=js"
import style0 from "./idCardPrinting.vue?vue&type=style&index=0&id=0efcabc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcabc0",
  null
  
)

export default component.exports